import React from 'react'
import { createGlobalStyle } from 'styled-components'

const CSSReset = createGlobalStyle`
/*
  1. Use a more-intuitive box-sizing model.
*/
*,
*::before,
*::after {
    box-sizing: border-box;
}

/*
  2. Remove default margin
*/
* {
    margin: 0;
    
}

/*
  3. Allow percentage-based heights in the application
*/
html,
body {
    height: 100%;
        overscroll-behavior: none;

}

/*
  Typographic tweaks!
  4. Add accessible line-height
  5. Improve text rendering
*/
body {
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
    background-color: white;
    overscroll-behavior: none;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
        'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
        sans-serif;
    
      scrollbar-color: #51646c #133040;
      scrollbar-width: thin;
    
}

/*
  6. Improve media defaults
*/
img,
picture,
video,
canvas,
svg {
    display: block;
    max-width: 100%;
}

/*
  7. Remove built-in form typography styles
*/
input,
button,
textarea,
select {
    font: inherit;
}

/*
  8. Avoid text overflows
*/
p,
h1,
h2,
h3,
h4,
h5,
h6 {
    overflow-wrap: break-word;
}

/*
  9. Create a root stacking context
*/
#root,
#__next {
    isolation: isolate;
    height: 100%;
}

`

const BaseStyles = createGlobalStyle`
  :root {
    font-size: 16px;
    font-weight: 400;

    color-scheme: light dark;

    font-synthesis: none;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-text-size-adjust: 100%;
  }

  html,
  body {
    min-height: 100%;
  }

  hr {
    margin: 12px 0;
    border: 1px solid rgba(51, 51, 51, 1);
  }

  body {
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
    overscroll-behavior: none;
    font-family:
      -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu',
      'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
    /* The first applies to the thumb of the scrollbar,  the second to the track. */
    scrollbar-color: rgba(102, 102, 102, 1) rgba(102, 102, 102, 0) !important;
    scrollbar-width: thin;
  }

  img,
  picture,
  video,
  canvas,
  svg {
    display: block;
    max-width: 100%;
  }

  h1,
  h2,
  h3 {
    font-family: Manrope, sans-serif;
    overflow-wrap: break-word;
  }

  p,
  h4,
  h5,
  h6 {
    overflow-wrap: break-word;
  }

  div {
    font-size: 14px;
  }

  small {
    font-size: 12px;
  }

  input {
    padding: 0.5rem;
    width: 100%;
    height: 35px;
    border-radius: 0.25rem;
    border-width: 1px;
    border-style: solid;
    overflow: hidden;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
  }

  input[type='number'] {
    -moz-appearance: textfield; /* Firefox */
    appearance: textfield;
  }

  input[type='date']::-webkit-calendar-picker-indicator {
    cursor: pointer;
  }

  label {
    font-size: 15px;
  }

  sub {
    font-size: 5px;
  }

  code {
    font-family:
      source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
  }

  ::-webkit-scrollbar {
    /* Track color */
    background: rgba(102, 102, 102, 0) !important;
    width: 10px;
  }

  ::-webkit-scrollbar-thumb {
    /* Thumb color */
    background-color: rgba(102, 102, 102, 0) !important;
    border-radius: 1000px;
    border: 1px solid rgba(102, 102, 102, 0) !important;
  }
`
const ScrollBarStyles = createGlobalStyle`
  ::-webkit-scrollbar {
  /* Track color */
  background-color: #133040;
  width: 10px;
}

::-webkit-scrollbar-thumb {
  /* Thumb color */
  background-color: #51646c;
  border-radius: 1000px;
  border: 2px solid hsl(201, 54%, 16%);
}

`

const VisxStyles = createGlobalStyle`
    .visx-tooltip-glyph svg {
        overflow: visible;
        width: 10px;
        height: 10px;
    }
`
// This fixes the Login image from looking squished. Will be fixed in the
// next gecko-ui release
const LoginDropdownCorrection = createGlobalStyle`
    div:has(div > div > div > img[alt="User profile"] ) {
        padding: 0 !important;

        &:focus {
            border: none;
        }
    }
`

const CenterTitle = createGlobalStyle`
    #HeaderContainer {
        grid-template-columns: 4fr min-content;
    }
`

const LoginMenuItem = createGlobalStyle`
    div[data-radix-popper-content-wrapper=""] div[role="menuitem"]:has(span,div[role="group"]) {
        min-width: 13rem;
    }
`

const FooterStyles = createGlobalStyle`
    footer.ant-layout-footer {
        color: ${({ theme }) => theme.forecast.secondaryText} !important;
        padding-top: 10px;
    }

    footer {
        display: none;
    }
`
const AdvancedControls = createGlobalStyle`
    .radix-themes:where([data-is-root-theme='true']) {
        min-height: 100px;
        box-shadow: none;
    }
`
const HeaderHeight = createGlobalStyle`
    #AppLayoutGrid {
        grid-template-rows: 4.375rem 1fr;
    }
`

const LoginDropDownProfile = createGlobalStyle`
    div[aria-label="Login dropdown"] {
        & div:nth-child(1) {
            flex-grow: 1;
        }

        & div:nth-child(2) {
            flex-shrink: 10;
            @media screen and (${({ theme }) => theme.queries.laptopAndSmaller}) {
                display: none;
            }
        }
    }
`

const Button = createGlobalStyle`
    .rs-btn-default:hover {
        background-color: ${({ theme }) => theme.forecast.background2} !important;
    }
`

const Picker = createGlobalStyle`
    .rs-btn.rs-picker-toggle {
        background-color: ${({ theme }) => theme.forecast.background1} !important;
    }

    .rs-picker-toggle-textbox {
        color: ${({ theme }) => theme.forecast.activeText};
    }

    .rs-picker-list-item {
        background-color: ${({ theme }) => theme.forecast.background1} !important;
        color: ${({ theme }) => theme.forecast.activeText};
    }

    .rs-check-item:hover {
        background-color: ${({ theme }) => theme.forecast.background2_5} !important;
    }

    .rs-picker-toggle-placeholder {
        color: ${({ theme }) => theme.forecast.defaultText} !important;
    }
    
    .rs-picker-toggle-indicator {
        svg {
            color: ${({ theme }) => theme.forecast.defaultText} !important;
        }
    }

    .rs-input-group, .rs-search-box-input {
        background-color: ${({ theme }) => theme.forecast.background2} !important;
        color: ${({ theme }) => theme.forecast.activeText};
    }
`

const PickerPopup = createGlobalStyle`
    div[data-testid="picker-popup"] {
        background-color: ${({ theme }) => theme.forecast.background1};
        z-index: 1000;
    }
`

const DateRangePickerButtonLink = createGlobalStyle`
    .rs-btn.rs-btn-link.rs-btn-sm {
        color: ${({ theme }) => theme.forecast.border};
    }
`

const DateRangePickerDateFocus = createGlobalStyle`
    .rs-calendar-table-cell-is-today .rs-calendar-table-cell-content {
        -webkit-box-shadow: inset 0 0 0 1px ${({ theme }) => theme.forecast.border} !important;
        box-shadow: inset 0 0 0 1px ${({ theme }) => theme.forecast.border} !important;
    }
`

const DateRangePickerOkButton = createGlobalStyle`
    .rs-btn-primary.rs-btn-disabled, .rs-btn-primary:disabled {
        color: ${({ theme }) => theme.forecast.background1};
        background-color: ${({ theme }) => theme.forecast.activeText};
    }

    .rs-btn-primary.rs-btn-active, .rs-btn-primary:hover {
        color: ${({ theme }) => theme.forecast.activeText};
        background-color: ${({ theme }) => theme.forecast.background2_5};
    }

    .rs-btn-primary {
        color: ${({ theme }) => theme.forecast.background1};
        background-color: ${({ theme }) => theme.forecast.activeText};
    }
`

const DateRangePickerCells = createGlobalStyle`
    --rs-btn-subtle-hover-text: ${({ theme }) => theme.forecast.activeText};
    --rs-btn-subtle-hover-bg: ${({ theme }) => theme.forecast.background2};

    .rs-btn-icon {
        color: ${({ theme }) => theme.forecast.icon1};
    }

    .rs-calendar-header-title {
        color: ${({ theme }) => theme.forecast.defaultText};
    }

    .rs-calendar-table-header-cell-content {
        color: ${({ theme }) => theme.forecast.defaultText};
    }

    .rs-calendar-table-cell-un-same-month .rs-calendar-table-cell-content {
        color: ${({ theme }) => theme.forecast.secondaryText};
    }

    .rs-calendar-table-cell-content {
        color: ${({ theme }) => theme.forecast.activeText};
    }

    .rs-calendar-table-cell-selected .rs-calendar-table-cell-content {
        color: ${({ theme }) => theme.forecast.activeText};
        background-color: ${({ theme }) => theme.forecast.background3};
    }

    .rs-picker-popup .rs-calendar .rs-calendar-table-cell:hover .rs-calendar-table-cell-content {
        background-color: ${({ theme }) => theme.forecast.background3};
    }

    .rs-calendar-table-cell-in-range:before {
        background-color: ${({ theme }) => theme.forecast.background3};
    }
`

const DateRangePickerInput = createGlobalStyle`
    .rs-input-group ::placeholder {
        color: ${({ theme }) => theme.forecast.secondaryText};
    }

    .rs-picker-input-group.rs-input-group {
        background-color: ${({ theme }) => theme.forecast.background3};
    }
    
    .rs-picker-input-group.rs-input-group input {
        background-color: ${({ theme }) => theme.forecast.background1};
        color: ${({ theme }) => theme.forecast.activeText};
    }

    .rs-input-group:focus-within, .rs-input-group:not(.rs-input-group-disabled).rs-input-group-focus, .rs-input-group:not(.rs-input-group-disabled):hover {
        border-color: ${({ theme }) => theme.forecast.background3} !important;
        color: ${({ theme }) => theme.forecast.activeText} !important;
    }

    .rs-input-group:focus-within, .rs-input-group:not(.rs-input-group-disabled).rs-input-group-focus, .rs-input-group:not(.rs-input-group-disabled) {
        border-color: ${({ theme }) => theme.forecast.background3} !important;
        color: ${({ theme }) => theme.forecast.activeText} !important;
    }

    .rs-picker-daterange > .rs-input-group.rs-input-group-inside .rs-input {
        background-color: ${({ theme }) => theme.forecast.background3} !important;
        color: ${({ theme }) => theme.forecast.activeText} !important;
    }

    .rs-picker-daterange > .rs-input-group.rs-input-group-inside .rs-input::placeholder {
        background-color: ${({ theme }) => theme.forecast.background3} !important;
        color: ${({ theme }) => theme.forecast.background4} !important;
    }

    .rs-picker-clean:has(.rs-icon) {
        color: ${({ theme }) => theme.forecast.secondaryText} !important;
    }

`

const DateRangePickerCloseButton = createGlobalStyle`
    .rs-icon {
        color: ${({ theme }) => theme.forecast.icon1};
    }

    .rs-btn-close {
        color: ${({ theme }) => theme.forecast.icon1};
    }

    .rs-btn-close:focus svg path, .rs-btn-close:hover svg path {
        color: ${({ theme }) => theme.forecast.icon1};
        stroke: ${({ theme }) => theme.forecast.icon1};
    }
`

const SelectorInputRsuite = createGlobalStyle`
    .rs-picker-toggle-value {
        color: ${({ theme }) => theme.forecast.activeText} !important;
    }

    .rs-picker-select-menu-item, .rs-picker-select-menu-item-active, .rs-picker-select-menu-item-focus {
        background-color: ${({ theme }) => theme.forecast.background1} !important;
        color: ${({ theme }) => theme.forecast.activeText} !important;

        &:hover {
            background-color: ${({ theme }) => theme.forecast.background3} !important;
        }
    }
`

const CheckPickerRsuite = createGlobalStyle`
    .rs-checkbox-checked .rs-checkbox-control .rs-checkbox-inner:before {
        background-color: ${({ theme }) => theme.forecast.border} !important;
        border-color: ${({ theme }) => theme.forecast.border} !important;
    }

    .rs-picker-value-count {
        background-color: ${({ theme }) => theme.forecast.background4} !important;
    }
`

const ManageUsersTable = createGlobalStyle`
    [data-page-name="manage-permissions"] .ant-table-cell-row-hover {
        cursor: pointer;
    }

    [data-page-name="manage-permissions"] .ant-table-cell {
        vertical-align: top
    }

    [data-page-name="manage-permissions"] .ant-table-wrapper .ant-table-filter-trigger.active {
        color: ${({ theme }) => theme.forecast.background2};
        background-color: ${({ theme }) => theme.colors.highVis};
    }

    [data-page-name="manage-permissions"] .ant-table-wrapper .ant-table-filter-trigger.active:hover {
        filter: brightness(130%);
    }
`

const AntdModalStyles = createGlobalStyle`
    .ant-modal-footer {
        button {
            box-shadow: none;
            &.ant-btn-variant-solid {
                background-color: ${({ theme }) => theme.colors.highVis} !important;
                color:black;
                font-weight: 500;
            }

            &.ant-btn-variant-solid:hover {
                background-color: #F5FF99 !important;
                color: black !important;
            }

            &.ant-btn-variant-outlined:hover {
                background-color: rgba(51, 51, 51, 1) !important;
            }
        }
    }
`

// No idea why the library doesn't just work, but its edges are position: absolute
// by default and they don't render at all unless they are changed to relative.
const ReactFlowStyles = createGlobalStyle`
    .react-flow .react-flow__edges {
        position: relative !important;
    }
`

export const GlobalStyles = () => (
  <>
    <CSSReset />
    <BaseStyles />
    <ScrollBarStyles />
    <AntdModalStyles />
    <LoginDropDownProfile />
    <HeaderHeight />
    <CenterTitle />
    <FooterStyles />
    <VisxStyles />
    <LoginDropdownCorrection />
    <LoginMenuItem />
    <AdvancedControls />
    <PickerPopup />
    <DateRangePickerButtonLink />
    <DateRangePickerDateFocus />
    <DateRangePickerOkButton />
    <DateRangePickerCells />
    <DateRangePickerInput />
    <DateRangePickerCloseButton />
    <Picker />
    <Button />
    <SelectorInputRsuite />
    <CheckPickerRsuite />
    <ManageUsersTable />
    <ReactFlowStyles />
  </>
)
